import {getCardById, updateCard} from "@model/card";
import {getTagById, getTagList, updateTag} from "@model/tag";
import {getNoteById, updateNote} from "@model/note";

let mDbFavorFolder:any;

export function initFavorFolder(db:any){
    mDbFavorFolder = db.table('favorFolder');
}

export function updateFavorFolder(favorFolder:any){
    if (favorFolder.children){
        //去重....
        const children:any = [];
        for (let i=0;i<favorFolder.children.length;i++){
            const item = favorFolder.children[i];
            if (!children.some(p=>p.id == item.id)){
                children.push(item);
            }
        }
        favorFolder.children = children;

        for (let i=0;i<favorFolder.children.length;i++){
            const item = favorFolder.children[i];
            if (item){
                delete item.html;
            }
        }
    }
    return mDbFavorFolder.put(favorFolder);
}

export function getFavorFolderList(){
    return mDbFavorFolder.toArray();
}

export function deleteFavorFolder(node:any){
    return new Promise(async (resolve) => {
        await mDbFavorFolder.delete(node.id);
        //删除这个文件夹下面的所有收藏
        for (let i=0;i<node.children.length;i++){
            const item = node.children[i];
            if (item.type == 'card'){
                const card = await getCardById(item.id);
                if (card){
                    card.isFavirated = 0;
                    card.sort = 0;
                    await updateCard(card);
                }
            }else if (item.type == 'tag'){
                const tag = await getTagById(item.id);
                if (tag){
                    tag.isFavirated = 0;
                    tag.sort = 0;
                    await updateTag(tag);
                }
            }else{
                const project = await getNoteById(item.id);
                if (project){
                    project.isFavirated = 0;
                    project.sort = 0;
                    await updateNote(project);
                }
            }
        }
        resolve('ok');
    })
}